module.exports = function () {
    if (window.Feature.detected.inputZoom) {
        $('input')
            .on('focus', function () {
                $('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
            })
            .on('blur', function () {
                $('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1, maximum-scale=2, user-scalable=yes');
            });
    }
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/disable-zoom.js